import apiClient from '../../lib/axios';

export const fetchPartners = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  const normalizedPage = Number.isFinite(Number(page)) ? Number(page) : 1;
  const normalizedLimit = Number.isFinite(Number(pageSize)) ? Number(pageSize) : 10;
  const clampedLimit = Math.max(1, Math.min(100, normalizedLimit));
  params.append('page', normalizedPage);
  params.append('limit', clampedLimit);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/partners?${params.toString()}`);
  return data;
};

export const fetchActivePartners = async () => {
  const { data } = await apiClient.get('/api/partners/active');
  return data;
};

export const createPartner = async (payload) => {
  const { data } = await apiClient.post('/api/partners', payload);
  return data;
};

export const updatePartner = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/partners/${id}`, payload);
  return data;
};

export const deletePartner = async (id) => {
  const { data } = await apiClient.delete(`/api/partners/${id}`);
  return data;
};

export const bulkUploadPartners = async ({ rows, updateExisting = true, dryRun = false }) => {
  const { data } = await apiClient.post('/api/partners/bulk-upload', {
    rows,
    updateExisting,
    dryRun,
  });
  return data;
};

export default fetchPartners;
